module.exports = __webpack_public_path__ + "static/img/profile2.f73f238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/profile2.jpg
// module id = o6li
// module chunks = 0